import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-neo-loader',
  templateUrl: './neo-loader.component.html',
  styleUrls: ['./neo-loader.component.scss']
})
export class NeoLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
